import React from 'react';
import Typography from '@mui/material/Typography';
import { useStates } from '../../hooks/StatesContext';
import Disclaimer from '../../components/FindAServicer/Disclaimer';
import PostalCodeForm from '../../components/FindAServicer/PostalCodeForm';
import StateForm from '../../components/FindAServicer/StateForm';
import { useRouter } from 'next/router';
import Head from 'next/head';
import useScreenResize from '../../hooks/useScreenResize';

interface Props {
  children: React.ReactElement;
}

function FindAServicer(props: Props) {
  const states = useStates();
  let router = useRouter();
  const [distance, setDistance] = React.useState(30);
  const [zip, setZip] = React.useState('');
  const [state_id, setStateId] = React.useState('');
  const [width, height] = useScreenResize();

  const { type, value } = router.query;
  
  React.useEffect(() => {
    syncForms(type, value, router.query.distance);
  }, [type, value, router.query.distance]);

  function changePage(type, value, query = '') {
    router.push('/find-a-servicer/' + type + '/' + value + query);
  }

  function submitGetByZip() {
    changePage('zip', zip, '?distance=' + distance);

    setStateId('');
  }

  function submitGetByState() {
    changePage('state', state_id);

    setZip('');
    setDistance(30);
  }

  function syncForms(type, value, dist = null) {
    if (type === 'zip') {
      setZip(value);
      setDistance(dist);
    } else {
      setStateId(value);
    }
  }

  return (
    <>
      <Head>
        <title>Find a Servicer | Fitness and Exercise Equipment Repair Parts</title>
        <meta
          name="description"
          content={'Find a servicer local to you to get your equipment back up and running.'}
        />
        <meta httpEquiv="content-language" content="en-us" />
      </Head>
      <div style={{ marginBottom: 15 }}>
        <div className='container-fluid' style={{ marginTop: 20 }}>
          <Typography variant="h3" className="mainbox">Service Provider Search</Typography>
          <div className='row' style={{ marginTop: 25 }}>
            <PostalCodeForm
              getServicersByZip={submitGetByZip}
              zip={zip}
              updateZip={setZip}
              distance={distance}
              updateDistance={setDistance}
              screenWidth={width}
            />
            <StateForm
              getServicersByState={submitGetByState}
              states={states}
              state_id={state_id}
              updateStateId={setStateId}
              screenWidth={width}
            />
          </div>
        </div>
        <div style={{ display: 'block', width: '100%' }}>
          {props.children}
          <Disclaimer />
        </div>
      </div>
    </>
  );
}

export default FindAServicer;
